import { render, staticRenderFns } from "./WorkRequestNew.vue?vue&type=template&id=5aa1f2eb&"
import script from "./WorkRequestNew.vue?vue&type=script&lang=ts&"
export * from "./WorkRequestNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports